import { useBuildChecklistMutation, useCreateCompanyInfoMutation } from "generated/credit-analysis-graphql";
import { useContinueLoanApplicationWorkFlowMutation } from "generated/graphql";
import { ApolloClientName } from "apollo-client-factory";
import useNavigation from "./navigation";
import { registerTagmanagerEvent, TagManagerEvent } from "configs/trackers";
import { getLoanApplicationParams } from "utils/utils";

type AntifraudeStep = "createCompanyInfo" | "buildChecklist" | "continueWorkflow";

export type AntifraudSteps =  AntifraudeStep[];

type AntifraudStepProps = {
    antifraudSteps: AntifraudSteps
}

export const useCompleteAntifraudStep =  ( { antifraudSteps }: AntifraudStepProps) => {

    const  loanApplicationId  = getLoanApplicationParams();

    const [continueWorkflow] = useContinueLoanApplicationWorkFlowMutation({
        variables: { loanApplicationId }
    });

    const [createCompanyInfo] = useCreateCompanyInfoMutation({
        context: { clientName: ApolloClientName.CreditAnalysisApi },
        variables: { loanApplicationId },
    });

    const [buildChecklist] = useBuildChecklistMutation({
        context: { clientName: ApolloClientName.CreditAnalysisApi },
        variables: { loanApplicationId },
    });

    const {
        goToDocumentCheckout,
        goToError,
    } = useNavigation();

    const getPromisses = (p: AntifraudeStep) => {
        const value = {
            "createCompanyInfo": createCompanyInfo(),
            "buildChecklist": buildChecklist(),
            "continueWorkflow": continueWorkflow()
        }
        return value[p] || null;
    }

    const handleCompleteAntiFraudStep = async () => {
        try {
            await Promise.all([antifraudSteps.map(as => getPromisses(as))]);
            goToDocumentCheckout();
            registerTagmanagerEvent(TagManagerEvent.IDENTIFICATION);
        } catch (error) {
            goToError();
        }
    }

    return {handleCompleteAntiFraudStep};
};
